import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../../Navbar'
import { ScaleLoader } from 'react-spinners';
import Select from 'react-select';
import Workbook from 'react-excel-workbook'
import CsvParse from '@vtex/react-csv-parse';
import moment from 'moment';
import ReactGA from 'react-ga';
const { proxy } = require('../../../ip_api.config')

class Film_MasterFocusTrade extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            previewItem: '',
            onPage: 'Preview',
            arr_temp_edit: [],
            arr_save: [],
            type_product: '',
            itemG3: '',
            ibrand1: '',
            itemG2: '',
            code: '',
            description: '',
            template: [{
                type_product: '',
                itemG3: '',
                ibrand1: '',
                itemG2: '',
                code: '',
                description: ''
            }],
            showUpload: '',
            upload_open: true,
            checkAll: true,
            checked: ''
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/flim/MasterFocusTrade');

        if (localStorage.getItem("ID_User") !== null) {
            this.getOption()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getOption = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_type_product = []
        let arroption_itemG3 = []
        let arroption_ibrand1 = []
        let arroption_itemG2 = []
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            type_product: '',
            itemG3: '',
            ibrand1: '',
            itemG2: '',
            code: '',
            description: '',
        }

        let url = proxy.server + '/flim/getMaster_FocusTrade'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {

                    arroption_type_product.push(
                        { value: val.type_product, label: val.type_product }
                    )
                    arroption_itemG3.push(
                        { value: val.itemG3, label: val.itemG3 }
                    )
                    arroption_ibrand1.push(
                        { value: val.ibrand1, label: val.ibrand1 }
                    )
                    arroption_itemG2.push(
                        { value: val.itemG2, label: val.itemG2 }
                    )
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)

                let newArray_type_product = await this.setUniqueArray(arroption_type_product)
                let newArray_itemG3 = await this.setUniqueArray(arroption_itemG3)
                let newArray_ibrand1 = await this.setUniqueArray(arroption_ibrand1)
                let newArray_itemG2 = await this.setUniqueArray(arroption_itemG2)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({
                    option_type_product: newArray_type_product,
                    option_itemG3: newArray_itemG3,
                    option_ibrand1: newArray_ibrand1,
                    option_itemG2: newArray_itemG2,
                    option_code: newArray_code,
                    option_description: newArray_description
                }, () => {
                    this.getMaster()
                })
            })
    }

    setUniqueArray = async (arroption) => new Promise((resolve, reject) => {
        let newArray = [];
        let uniqueObject = {};

        for (let i in arroption) {
            let objTitle = arroption[i]['value'];
            uniqueObject[objTitle] = arroption[i];
        }

        for (let i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }
        resolve(newArray)
    })

    getMaster = () => {
        this.setState({ isLoading: true, onPage: 'Preview', checkAll: true })
        const { type_product, itemG3, ibrand1, itemG2, code, description } = this.state
        let arr = []
        let dataWhere = {
            type_product: type_product,
            itemG3: itemG3,
            ibrand1: ibrand1,
            itemG2: itemG2,
            code: code,
            description: description,
        }
        let url = proxy.server + '/flim/getMaster_FocusTrade'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            {
                                val.type_product === 'Focus/Trade'
                                    ? <td style={{ backgroundColor: '#deeaf6' }}>{val.type_product}</td>
                                    : val.type_product === 'Ablemen'
                                        ? <td style={{ backgroundColor: '#fad257' }}>{val.type_product}</td>
                                        : <td style={{ backgroundColor: '#ccffcc' }}>{val.type_product}</td>
                            }
                            <td>{val.itemG3}</td>
                            <td>{val.ibrand1}</td>
                            <td>{val.itemG2}</td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    arrDataExcel: responseJson.result, filename: 'MasterFocusTrade' + moment().format('YYYYMMDD')
                })
            })
    }

    getItem_Edit = () => {
        this.setState({ isLoading: true, onPage: 'Edit' })
        const { type_product, itemG3, ibrand1, itemG2, code, description } = this.state
        let arr = []
        let dataWhere = {
            type_product: type_product,
            itemG3: itemG3,
            ibrand1: ibrand1,
            itemG2: itemG2,
            code: code,
            description: description,
        }
        let url = proxy.server + '/flim/getMaster_FocusTrade'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td style={{ justifyContent: 'center' }}>
                                {/* <bs4.Col>
                                    <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                        onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                </bs4.Col> */}
                                <bs4.Col>
                                    {
                                        this.state.checked === ''
                                            ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                                onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                            : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                    }
                                </bs4.Col>
                            </td>
                            {
                                val.type_product === 'Focus/Trade'
                                    ? <td style={{ backgroundColor: '#deeaf6' }}>{val.type_product}</td>
                                    : val.type_product === 'Ablemen'
                                        ? <td style={{ backgroundColor: '#fad257' }}>{val.type_product}</td>
                                        : <td style={{ backgroundColor: '#ccffcc' }}>{val.type_product}</td>
                            }
                            <td>{val.itemG3}</td>
                            <td>{val.ibrand1}</td>
                            <td>{val.itemG2}</td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({ previewItem: arr, isLoading: false })
            })
    }

    checkItem = (check, id) => {
        let data = {}
        if (check === true) {
            data = {
                id: id,
            }
            let arr = this.state.arr_temp_edit.concat(data)
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        } else {
            let arr = this.state.arr_temp_edit

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        }
    }

    checkAll = (check) => {
        let arr = []
        let data = ''
        // let data = {}

        if (check) {
            data = 'checked'
            this.state.result.map(function (val, i) {
                arr.push({
                    id: val.id
                })
            })
        }

        this.setState({
            arr_temp_edit: arr,
            checkAll: !this.state.checkAll,
            checked: data
        }, () => {
            console.log('arr_temp_edit', this.state.arr_temp_edit)
            this.getItem_Edit()
        })
    }

    goto_edit = () => {
        this.props.history.push({
            pathname: '/Flim/editMasterFocusTrade',
            state: { id_edit: this.state.arr_temp_edit }
        })
    }

    Delete_item = (id) => {
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/delete_masterFocusTrade'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.setState({ arr_save: [], show_item: '' }, () => this.getMaster())
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถลบข้อมูลได้ กรุณาตรวจสอบอีกครั้ง')
                        })
                    }
                })
        }
    }

    addData = () => {
        const { arr_save } = this.state
        let arr = []
        let temp
        // arr_check.map(function (val, i) {
        let data = {
            type_product: '',
            itemG3: '',
            ibrand1: '',
            itemG2: '',
            code: '',
            description: ''
        }

        arr.push(data)

        temp = arr_save.concat(arr)

        this.setState({
            arr_save: temp
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.showItem()
        })
    }

    showItem = () => {
        let arr = []
        this.state.arr_save.map(function (val, i) {
            arr.push(
                <tr>
                    <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="type_product" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="itemG3" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="ibrand1" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="itemG2" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                </tr>
            )
        }, this)

        this.setState({ show_item: arr }, () => {
            console.log('arr_save', this.state.arr_save)
        })
    }

    onDelete = (index) => {
        this.state.arr_save.splice(index, 1)
        this.setState({
            arr_save: this.state.arr_save,
        }, () => {
            this.showItem()
        })
    }

    handleChangeItem = (index, name, value) => {
        if (name === 'type_product') {
            this.state.arr_save[index].type_product = value
        } else if (name === 'itemG3') {
            this.state.arr_save[index].itemG3 = value
        } else if (name === 'ibrand1') {
            this.state.arr_save[index].ibrand1 = value
        } else if (name === 'itemG2') {
            this.state.arr_save[index].itemG2 = value
        } else if (name === 'code') {
            this.state.arr_save[index].code = value
        } else if (name === 'description') {
            this.state.arr_save[index].description = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            this.showItem()
        })
    }

    saveItem = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            let url = proxy.server + '/flim/insert_masterFocusTrade'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify(this.state.arr_save)
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        alert('บันทึกสำเร็จ')
                        this.setState({ arr_save: [], show_item: '' }, () => this.getMaster())
                    } else {
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    allData_Preveiw = () => {
        window.location.reload()
    }

    showUpload = () => {
        const keys = [
            'type_product', 'itemG3', 'ibrand1', 'itemG2', 'code', 'description'
        ]
        if (this.state.upload_open === true) {
            var Upload = <bs4.FormGroup row style={{ marginLeft: '25px', marginBottom: '25px', marginRight: 40 }}>
                <bs4.Label style={{ color: 'red', marginRight: "20px" }}> **รองรับเฉพาะไฟล์ .csv เท่านั้น</bs4.Label>
                <CsvParse
                    keys={keys}
                    onDataUploaded={(data) => { this.setState({ arr_save: data }) }}
                    onError={this.handleError}
                    render={onChange => <input type="file" onChange={onChange} />
                    }
                />
            </bs4.FormGroup>
        }

        this.setState({ showUpload: Upload, upload_open: !this.state.upload_open })
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>type_product</bs4.Label>
                    <bs4.Col sm='3'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ type_product: e.value })}
                            options={this.state.option_type_product}
                            placeholder={'ค้นหา type_product'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>itemG3</bs4.Label>
                    <bs4.Col sm='3'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ itemG3: e.value })}
                            options={this.state.option_itemG3}
                            placeholder={'ค้นหา itemG3'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>itemG2</bs4.Label>
                    <bs4.Col sm='3'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ itemG2: e.value })}
                            options={this.state.option_itemG2}
                            placeholder={'ค้นหา itemG2'}
                        />
                    </bs4.Col>
                </bs4.FormGroup>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>ibrand1</bs4.Label>
                    <bs4.Col sm='2'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ ibrand1: e.value })}
                            options={this.state.option_ibrand1}
                            placeholder={'ค้นหา ibrand1'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                    <bs4.Col sm='2'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ code: e.value })}
                            options={this.state.option_code}
                            placeholder={'ค้นหา code'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                    <bs4.Col sm='2'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ description: e.value })}
                            options={this.state.option_description}
                            placeholder={'ค้นหา description'}
                        />
                    </bs4.Col>
                    <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getMaster()}>SEARCH</bs4.Button>
                    <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.allData_Preveiw()}>ดูข้อมูลทั้งหมด</bs4.Button>
                </bs4.FormGroup>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 23, fontWeight: 500, marginRight: 10, marginBottom: 20 }}>ข้อมูล Focus/Trade</bs4.Label>
                    {
                        this.state.onPage === 'Preview'
                            ? <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.addData()}>ADD DATA</bs4.Button>
                                <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getItem_Edit()}>EDIT</bs4.Button>
                            </div>
                            : <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.goto_edit()}>GO TO EDIT</bs4.Button>
                                <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.getMaster()}>CANCEL</bs4.Button>
                            </div>

                    }
                    <div style={{ justifyContent: 'flex-end' }}>
                        <Workbook filename={this.state.filename + '.xlsx'} element={<bs4.Button outline color="success" style={{ fontWeight: 500, marginRight: 20 }}>EXPORT EXCEL</bs4.Button>} >
                            <Workbook.Sheet data={this.state.arrDataExcel} name="sheet1">
                                <Workbook.Column label="type_product" value="type_product" />
                                <Workbook.Column label="itemG3" value="itemG3" />
                                <Workbook.Column label="ibrand1" value="ibrand1" />
                                <Workbook.Column label="itemG2" value="itemG2" />
                                <Workbook.Column label="code" value="code" />
                                <Workbook.Column label="description" value="description" />
                            </Workbook.Sheet>
                        </Workbook>
                        <bs4.Button color="warning" outline style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.showUpload()}>IMPORT</bs4.Button>
                        <Workbook filename={'templateFocusTrade.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                            <Workbook.Sheet data={this.state.template} name="sheet1">
                                <Workbook.Column label="type_product" value="type_product" />
                                <Workbook.Column label="itemG3" value="itemG3" />
                                <Workbook.Column label="ibrand1" value="ibrand1" />
                                <Workbook.Column label="itemG2" value="itemG2" />
                                <Workbook.Column label="code" value="code" />
                                <Workbook.Column label="description" value="description" />
                            </Workbook.Sheet>
                        </Workbook>
                    </div>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>

                <bs4.FormGroup row style={{ marginLeft: 10 }}>
                    {this.state.showUpload}
                    {
                        this.state.arr_save.length > 0
                            ? <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.saveItem()}>SAVE</bs4.Button>
                                <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ arr_save: [], showUpload: '' }, () => this.showItem())}>CANCEL</bs4.Button>
                            </div>
                            : ''
                    }
                </bs4.FormGroup>
                <bs4.Table bordered hover>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th style={{ backgroundColor: '#fff' }}>
                                {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                            </th>
                            <th>type_product</th>
                            <th>itemG3</th>
                            <th>ibrand1</th>
                            <th>itemG2</th>
                            <th>code</th>
                            <th>description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.show_item}
                        {this.state.previewItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Film_MasterFocusTrade